import { VisualShape } from 'app/frontend/types/custom/VisualPlan'
import { getIconLabel } from '../iconKinds'
import { isIconShape } from './iconShapes'

export const SHAPE_TYPE_LABELS: Record<
  Exclude<VisualShape['type'], 'icon'>,
  string
> = {
  rect: 'Rectangle',
  circle: 'Circle',
  triangle: 'Triangle',
  arrow: 'Arrow',
  line: 'Line',
  pencil: 'Drawing',
  text: 'Text',
}

export const shapeDisplayLabel = (shape: VisualShape): string => {
  if (isIconShape(shape)) return getIconLabel(shape.kind, shape.value)
  return SHAPE_TYPE_LABELS[shape.type]
}

export const nextShapeName = (
  shapes: VisualShape[],
  type: Exclude<VisualShape['type'], 'icon'>,
): string => {
  const label = SHAPE_TYPE_LABELS[type]
  const taken = new Set(shapes.map((s) => s.name))
  let n = 1
  while (taken.has(`${label} ${n}`)) n++
  return `${label} ${n}`
}

export const nextIconName = (
  shapes: VisualShape[],
  kind: Extract<VisualShape, { type: 'icon' }>['kind'],
  value: string,
): string => {
  const label = getIconLabel(kind, value)
  const taken = new Set(shapes.map((s) => s.name))
  let n = 1
  while (taken.has(`${label} ${n}`)) n++
  return `${label} ${n}`
}

export const nextPastedName = (
  baseName: string,
  taken: Set<string | undefined>,
): string => {
  let n = 1
  while (taken.has(`${baseName} (${n})`)) n++
  return `${baseName} (${n})`
}
